import axios from 'axios'
import Delivery from '@/dto/deliveries/Delivery'
import Field from '@/dto/deliveries/Field'
import DeliveryFactory from '@/services/factories/DeliveryFactory'

const DeliveryService = {
  getDeliveries(shipmentPointId: number): Promise<Delivery[]> {
    return axios
      .get(`/admin/shipment-points/${shipmentPointId}/deliveries`)
      .then(response => response.data.deliveries)
  },

  getFields({
    deliveryType,
    calculatorType,
    deliveryId,
  }: {
    deliveryType: string
    calculatorType: string
    deliveryId: number | null
  }): Promise<Field[]> {
    return axios
      .get('/admin/deliveries/fields', {
        params: { type: deliveryType, calculatorType, deliveryId },
      })
      .then(response => response.data.fields)
  },

  saveDelivery(delivery: Delivery): Promise<Delivery> {
    const deliveryId = delivery.id
    const request =
      deliveryId === null
        ? axios.post('/admin/deliveries', delivery)
        : axios.put(`/admin/deliveries/${deliveryId}`, delivery)

    return request.then(response => response.data.delivery)
  },

  removeDelivery(deliveryId: number | null): Promise<string> {
    return axios.delete(`/admin/deliveries/${deliveryId}`)
  },

  makeDeliveryModel: DeliveryFactory,
}

export default DeliveryService
